import React, { useState, useEffect, useContext } from "react";
import { Container, Row, Col, Card, CardBody, Table, Button } from "reactstrap";

import { getOrdersByBoatOwner } from "../../../../api/order/orderApi";
import { getOrderSummaryByBoatOwner } from "../../../../api/order/orderApi";
import { getSalesData } from "../../../../api/order/orderApi";
import "./cofrequest.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faShoppingCart,
  faRefresh,
  faRocket,
  faCreditCard,
  faSpaghettiMonsterFlying,
} from "@fortawesome/free-solid-svg-icons";
import { motion } from "framer-motion";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import DataTable from "react-data-table-component";
import { AuthContext } from "../../../ExtraPages/AuthProvider";
// Register the necessary Chart.js components
ChartJS.register(
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Title,
  Tooltip,
  Legend
);
// Example data for charts and table
const orderData = [
  { month: "Jan", orders: 500 },
  { month: "Feb", orders: 600 },
  { month: "Mar", orders: 550 },
  { month: "Apr", orders: 700 },
  { month: "May", orders: 800 },
  { month: "Jun", orders: 850 },
];

const OrderDashboard = () => {
  const [orders, setOrders] = useState([]);
  const [ordersSummary, setOrdersSummary] = useState({});
  const { user } = useContext(AuthContext);
  const [userId, setUserId] = useState(null);
  const [monthlySales, setMonthlySales] = useState({
    labels: [],
    datasets: [
      {
        label: '',
        data: [],
        backgroundColor: [],
        borderColor: [],
        borderWidth: 1,
      },
    ],
  });
  const data = {
    labels: ['January', 'February', 'March', 'April', 'May', 'June'],
    datasets: [
      {
        label: 'Sales ($)',
        data: [0, 0, 0, 0, 0, 0],
        backgroundColor: [
          'rgba(255, 99, 132, 0.5)',
          'rgba(54, 162, 235, 0.5)',
          'rgba(255, 206, 86, 0.5)',
          'rgba(75, 192, 192, 0.5)',
          'rgba(153, 102, 255, 0.5)',
          'rgba(255, 159, 64, 0.5)',
        ],
        borderColor: [
          'rgba(255, 99, 132, 1)',
          'rgba(54, 162, 235, 1)',
          'rgba(255, 206, 86, 1)',
          'rgba(75, 192, 192, 1)',
          'rgba(153, 102, 255, 1)',
          'rgba(255, 159, 64, 1)',
        ],
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        text: 'Monthly Sales Line Chart',
      },
    },
    scales: {
      y: {
        beginAtZero: true,
      },
    },
  };

  // Define columns
  // Helper: parse Order_Date into a timestamp reliably for sorting
  const parseOrderDate = (d) => {
    if (!d) return 0;
    // If already a Date or timestamp
    if (d instanceof Date) return d.getTime();
    if (typeof d === 'number') return d;

    // Try native parse first (handles ISO formats)
    const native = new Date(d);
    if (!isNaN(native.getTime())) return native.getTime();

    // Try common DD-MM-YYYY or DD/MM/YYYY formats by reordering to YYYY-MM-DD
    const parts = String(d).trim().split(/[-\/]/);
    if (parts.length === 3) {
      // If first segment looks like a year (4 digits) assume YYYY-MM-DD
      if (parts[0].length === 4) {
        const iso = `${parts[0]}-${parts[1].padStart(
          2,
          '0'
        )}-${parts[2].padStart(2, '0')}`;
        const tryIso = new Date(iso);
        if (!isNaN(tryIso.getTime())) return tryIso.getTime();
      }

      // Otherwise assume DD-MM-YYYY or DD/MM/YYYY -> convert
      const reordered = `${parts[2]}-${parts[1].padStart(
        2,
        '0'
      )}-${parts[0].padStart(2, '0')}`;
      const tryRe = new Date(reordered);
      if (!isNaN(tryRe.getTime())) return tryRe.getTime();
    }

    // Fallback: parse with Date.parse or return 0
    const parsed = Date.parse(d);
    return isNaN(parsed) ? 0 : parsed;
  };
  const columns = [
    {
      id: 1,
      name: 'Date',
      selector: (row) => {
        const ts = parseOrderDate(row.Order_Date);
        return ts ? new Date(ts).toLocaleString() : '';
      },
      sortable: true,
      sortFunction: (rowA, rowB) => {
        return (
          parseOrderDate(rowA.Order_Date) - parseOrderDate(rowB.Order_Date)
        );
      },
    },

    {
      name: 'Product',
      selector: (row) => row.Product_Name,
      sortable: true,
    },
    {
      name: 'Status',
      selector: (row) => row.Status,
    },
    {
      name: 'Quantity',
      selector: (row) => row.quantity,
      sortable: true,
    },
    {
      name: 'Unit Price (kg)',
      selector: (row) => row.Price_per_Kg,
      sortable: true,
    },

    {
      name: 'Total',
      selector: (row) => row.quantity * row.Price_per_Kg,
      sortable: true,
      right: true, // Aligns the content to the right
    },
  ];

  useEffect(() => {
    console.log('user', user);
    if (!user) return;
    setUserId(user.uid);
  }, [user]);

  useEffect(() => {
    if (!userId) return;
    const fetchOrders = async () => {
      try {
        console.log('userId', userId);
        const response = await getOrdersByBoatOwner(userId);

        const response1 = await getOrderSummaryByBoatOwner(userId);
        const response2 = await getSalesData(userId, '2025');
        console.log('response2', response);
        setOrders(response.data.data); // Set CofRequests data to state
        setOrdersSummary(response1.data.data);
        // console.log(response2.data);
        setMonthlySales(response2.data);
      } catch (err) {
        //setError("Error fetching CofRequests"); // Set error message if the API call fails
      } finally {
        console.log(monthlySales);
        //setLoading(false); // Set loading to false once the API call is done
      }
    };

    fetchOrders(); // Call the function to fetch CofRequests
  }, [userId]); // Trigger the effect when boatOwner changes

  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }} // Initial state
      animate={{ opacity: 1, y: 0 }} // Animation when component mounts
      exit={{ opacity: 0, y: -20 }} // Exit animation
      transition={{ duration: 0.5 }} // Transition duration
    >
      <Container
        fluid
        className="mt-4"
        style={{ marginLeft: '0px' }}
      >
        <Row
          className="g-4"
          style={{
            background: 'white',
            marginBottom: '20px',
            padding: '30px',
            borderRadius: '20px',
          }}
        >
          {(() => {
            const orderCards = [
              {
                title: 'Total Orders',
                value: ordersSummary.totalOrders || 0,
                icon: faShoppingCart,
                background: '#00A991',
                className: 'border-right1',
              },
              {
                title: 'Today',
                value: ordersSummary.ordersToday || 0,
                icon: faShoppingCart,
                background: '#EFC059',
                className: 'border-right1',
              },
              {
                title: 'This month',
                value: ordersSummary.newOrdersThisMonth || 0,
                icon: faShoppingCart,
                background: '#EA5C4C',
                className: '',
              },
              {
                title: 'Processing',
                value: ordersSummary.processingOrders || 0,
                icon: faRefresh,
                background: '#D3862A',
                className: 'border-right1',
              },
              {
                title: 'Shipped',
                value: ordersSummary.shippedOrders || 0,
                icon: faRocket,
                background: '#003B8F',
                className: 'border-right1',
              },
              {
                title: 'Delivered',
                value: ordersSummary.deliveredOrders || 0,
                icon: faCreditCard,
                background: '#9747FF',
                className: '',
              },
            ];
            return orderCards.map((card, index) => (
              <Col
                sm={12}
                lg={4}
                md={12}
                key={index}
              >
                <div className={card.className}>
                  <div
                    className="m-b-20"
                    style={{ color: 'black' }}
                  >
                    <FontAwesomeIcon
                      icon={card.icon}
                      className="f-left"
                      style={{
                        fontSize: '1.2rem',
                        borderRadius: '40px',
                        padding: '10px',
                        background: card.background,
                        color: 'white',
                      }}
                    />
                    <div style={{ position: 'relative', left: '20px' }}>
                      <div className="text-black">{card.title}</div>
                      <div>
                        <h3>{card.value}</h3>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            ));
          })()}
        </Row>
        <Row
          className="g-4"
          style={{
            background: 'white',
            marginTop: '10px',
            padding: '20px',
            borderRadius: '20px',
          }}
        >
          <Col md="12">
            <div style={{ backgroundColor: '#fff', padding: '20px' }}>
              <h5>Order Listss</h5>
              <div className="table-responsive"></div>
              <DataTable
                columns={columns}
                data={orders}
                pagination
                defaultSortFieldId={1}
                defaultSortAsc={false}
              />
            </div>
          </Col>
        </Row>

        <Row
          className="g-4"
          style={{
            background: 'white',
            marginTop: '10px',
            padding: '20px',
            borderRadius: '20px',
          }}
        >
          <Col md="12">
            <div style={{ backgroundColor: '#fff', padding: '20px' }}>
              <div style={{ color: 'black' }}>
                <h5>Monthly Order Count</h5>
                <Line
                  data={monthlySales}
                  options={options}
                />
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </motion.div>
  );
};

export default OrderDashboard;
